import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CarouselComponent, OwlOptions } from 'ngx-owl-carousel-o';
import { SetVisoreHero1 } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-carousel-hero-bar',
  templateUrl: './carousel-hero-bar.component.html',
  styleUrls: ['./carousel-hero-bar.component.scss']
})
export class CarouselHeroBarComponent implements OnInit {
  @Input() public carouselItems: SetVisoreHero1[] = []
  @Input() public id: string = "1"
  @Output() public changeSlideEmitter = new EventEmitter<string>();
  @ViewChild("carousel") public carousel?: CarouselComponent
  public domainWebsite = environment.urlApi;
  public imgPath = ""
  public testoAlt = ""
  public customOptionsOwl?: OwlOptions

  constructor(private helperService: HelpersService) { }

  ngOnInit(): void {
    this.customOptionsOwl = {
      loop: true,
      mouseDrag: true,
      touchDrag: true,
      pullDrag: true,
      dots: false,
      center: true,
      navSpeed: 700,
      margin: 0,
      stagePadding: 200,
      items: this.carouselItems?.length < 3 ? this.carouselItems?.length : 3,
      responsive: {
        1024: {
          items: 4
        }
      },
    };
  }

  public getImgPath(item: SetVisoreHero1): string {
    return this.domainWebsite + this.helperService.retrieveImage(item.immagine, "src");
  }
  public getTestoAlt(item: SetVisoreHero1): string {
    return this.domainWebsite + this.helperService.retrieveImage(item.immagine, "alt");
  }

  public selectItem(id: number) {
    this.changeSlideEmitter.emit(id.toString())
  }

  public moveTo(id: string) {
    if (this.carousel && this.carousel.slides.length) {
      this.carousel.to(id)
    }
  }



}
